import { useState, useCallback } from 'react';

export const usePinValidation = () => {
    const [errors, setErrors] = useState({});

    const validatePin = useCallback((pin) => {
        const newErrors = {};

        // タイトルのみ必須
        if (!pin.title || !pin.title.trim()) {
            newErrors.title = 'タイトルは必須です';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }, []);

    const clearErrors = useCallback(() => {
        setErrors({});
    }, []);

    const clearFieldError = useCallback((fieldName) => {
        setErrors(prev => {
            const newErrors = { ...prev };
            delete newErrors[fieldName];
            return newErrors;
        });
    }, []);

    return {
        errors,
        validatePin,
        clearErrors,
        clearFieldError
    };
};
